import { Pipe, PipeTransform } from '@angular/core';

import { ÉTAT_GROUPE } from '../enum/état-groupe.enum';

@Pipe({
  name: 'convertEtatGroupeToString',
})
export class ConvertEtatGroupeToStringPipe implements PipeTransform {
  transform(état?: ÉTAT_GROUPE): string {
    switch (état) {
      case ÉTAT_GROUPE.A_FAIRE:
        return 'À Faire';
      case ÉTAT_GROUPE.A_VALIDER:
        return 'À Valider';
      case ÉTAT_GROUPE.VALIDE:
        return 'Validé';
      case ÉTAT_GROUPE.REJETE:
        return 'Rejeté';
      default:
        return 'À Faire';
    }
  }
}
